import React, { useEffect, useState } from 'react';
import {
  isEmpty,
  applyTruncationForAllScreen,
  findValueByKey,
  isLinkAbsolute,
  correctInternalLink,
  getImage,
  getResourceContentImageSrc,
  stripHtml,
  removeNbsp,
  isItUndefined,
  noTruncationForAllScreen,
} from '../../util/DataUtil';
import { useRouter } from 'next/router';
import { Constants } from '../../util/Constants';
import Image from 'next/image';
import CtaBarButton from '../base/cta-bar-button';
import { getObjectValueByMachineName } from '../../util/ObjectUtil';
import Link from 'next/link';
import FacilityModal from '../modal/FacilityModal';
import ArticleThumbnailCard from '../shared/ArticleThumbnailCard';

export default function TemplateRelated({
  data,
  title,
  primaries,
  otherData,
  global,
}) {
  if (!data || data.length === 0 || isEmpty(data[0])) {
    return '';
  }
  const viewAllLink = otherData?.field_view_all_link_override?.[0]?.value
    ? otherData?.field_view_all_link_override?.[0]?.value
    : '/resources';

  const router = useRouter();
  const { asPath } = router;

  const [titles, setTitles] = useState([]);
  const [marketoTrigger, setMarketoTrigger] = useState(false);
  if (
    data &&
    Object.keys(data).length === 0 &&
    Object.getPrototypeOf(data) === Object.prototype
  ) {
    return '';
  }

  const truncate = () => {
    const titles = data.map((item) => {
      const templateTitle = findValueByKey(
        'template_title_block_type',
        item?.field_template_blocks
      )?.field_template_title?.[0]?.value;
      const heroFormattedTitle = removeNbsp(
        stripHtml(
          findValueByKey('hero_graphic_block_type', item?.field_template_blocks)
            ?.field_formatted_title?.[0]?.value
        )
      );
      const nodeTitle = item.title;
      if (!templateTitle && !heroFormattedTitle && !nodeTitle) {
        return '';
      }

      return [
        truncateTextByItemCount(templateTitle) ||
          truncateTextByItemCount(heroFormattedTitle) ||
          truncateTextByItemCount(nodeTitle),
      ];
    });

    setTitles(titles);
  };

  useEffect(() => {
    truncate();
  }, [data]);

  const getContentTypeLabel = (item) => {
    if (item?.field_facility_location?.length > 0) {
      return global?.field_facility_label?.[0]?.value || 'Facility';
    }

    if (item?.field_metro_name?.length > 0) {
      return global?.field_metro_label?.[0]?.value || 'Metro';
    }

    if (item?.field_region_name?.length > 0) {
      return global?.field_region_label?.[0]?.value || 'Region';
    }

    return (
      item?.field_content_type_templat?.[0]?.name ||
      item?.field_page_type?.[0]?.value ||
      null
    );
  };

  const onChipClick = (event, category) => {
    // if (typeof window !== "undefined") {
    //     localStorage.setItem('name', category[0]['name'])

    //     if(window.location.pathname !== '/resources'){
    //         router.push('/resources');
    //     }
    // }

    if (typeof window !== 'undefined') {
      // localStorage.setItem('name', category[0]['name'])
      if (window.location.pathname !== '/resources') {
        // router.push('/resources');
        router.push({
          pathname: '/resources',
          query: { category: category[0]['name'].toLowerCase() },
        });
      }
    }
  };

  const onViewAll = (event, categories) => {
    if (typeof window !== 'undefined') {
      // if (
      //   otherData?.field_view_all_link_override?.[0]?.value &&
      //   otherData?.field_view_all_link_override?.[0]?.value !== '/resources'
      // ) {
      // event.preventDefault();
      // router.push(otherData?.field_view_all_link_override?.[0]?.value);
      // return;
      // }

      if (!categories[0]) {
        return;
      }

      localStorage.setItem('name', categories[0]);

      // if (window.location.pathname !== '/resources') {
      //   event.preventDefault();
      //   router.push('/resources');
      // }
    }
  };

  const truncateTextByItemCount = (value) => {
    if (!value) {
      return;
    }

    let truncation;

    if (data.length == 1) {
      truncation = noTruncationForAllScreen(value, 60, 60, 60, 60);
    } else if (data.length == 2) {
      truncation = noTruncationForAllScreen(value, 82, 60, 60, 60);
    } else if (data.length == 3) {
      truncation = noTruncationForAllScreen(value, 55, 60, 60, 60);
    } else if (data.length == 4) {
      truncation = noTruncationForAllScreen(value, 55, 43, 45, 18, 32, 37);
    }
    return truncation;
  };

  // Subheader meta (the "article category" line): content type in the author's
  // position + time to read, using the same blog-info structure/classes as the
  // other Resource areas so the shared card styles it identically. Newsroom has
  // no content type/time, so this returns null and the card hides the row.
  const renderMeta = (item) => {
    const label = getContentTypeLabel(item);
    const time = item?.field_time_to_read?.[0]?.value;
    if (!label && !time) return null;
    return (
      <div className={'blog-info'}>
        {label ? <span className={'info-item'}>{label}</span> : null}
        {label && time ? (
          <span className={'separator separator-inline info-item'}>
            {' | '}
          </span>
        ) : null}
        {time ? (
          <span className={'blog-read-time info-item'}>{time}</span>
        ) : null}
      </div>
    );
  };

  // Tag chip click keeps the existing behaviour (jump to /resources filtered by
  // the clicked category). Newsroom has no tags, so this never fires there.
  const handleTagClick = (event, tag) => {
    if (tag?.name) {
      onChipClick(event, [{ name: tag.name }]);
    }
  };

  const renderRelated = () => {
    if (!data.length) {
      return;
    }

    return data.map((item, index) => {
      if (!item['url-alias']) {
        return;
      }

      return (
        <ArticleThumbnailCard
          key={`related-key-${item?.['url-alias'] || item?.nid || index}`}
          className="item"
          twoCol={data.length === 2}
          href={item['url-alias']}
          target={isLinkAbsolute(item['url-alias']) ? '_blank' : '_self'}
          image={getResourceContentImageSrc(item)}
          imageAlt="template-related"
          header={
            isItUndefined(item?.field_display_title)
              ? isItUndefined(item?.field_display_title)
              : titles[index]
          }
          subheader={renderMeta(item)}
          primaryCategory={item?.field_template_category?.[0]}
          secondaryCategories={item?.field_template_secondary_categor}
          onTagClick={handleTagClick}
        />
      );
    });
  };

  return (
    <>
      <div className={'related-block inner-container'}>
        <div className={'template-related container-length-' + data.length}>
          <div className={'top'}>
            {asPath == '/' ||
            asPath?.includes('home-global-v2') ||
            asPath == '/home' ? (
              <h3
                className={`page-sub ${asPath == '/' || asPath?.includes('home-global-v2') || asPath == '/home' ? 'home-global' : ''}`}
              >
                {title}
              </h3>
            ) : (
              <span className={'page-sub'}>{title}</span>
            )}
            {(otherData?.field_view_all_text_override?.[0] ||
              global.field_view_all_text?.[0]) && (
              <Link href={viewAllLink} passHref>
                <a
                  onClick={(e) => onViewAll(e, primaries)}
                  className={`a-related-content-link cta-link`}
                >
                  {otherData?.field_view_all_text_override?.[0]?.value ||
                    global.field_view_all_text?.[0]?.value}
                  <img
                    alt="arrow"
                    className="more-arrow"
                    src="/images/more-arrow.svg"
                  />
                </a>
              </Link>
            )}
          </div>
          <hr />
          {isItUndefined(otherData.field_display_block) == '1' ? (
            <div className="related-wrapper">
              <div className="left-side">
                <div
                  dangerouslySetInnerHTML={{
                    __html: getObjectValueByMachineName(
                      otherData?.field_description[0]?.value,
                      global
                    ),
                  }}
                  className={'description'}
                />
                {otherData?.field_cta_bar_button_selection?.length > 0 ? (
                  <CtaBarButton
                    blockTypeClass={'template-related'}
                    setMarketoTrigger={setMarketoTrigger}
                    data={
                      otherData?.field_cta_bar_button_selection[0]
                        ?.cta_bar_button
                    }
                    pathname={true}
                  />
                ) : (
                  <></>
                )}
              </div>
              <div className="right-side">
                <Link
                  href={otherData?.field_featured_content_link?.[0]?.value}
                  passHref
                >
                  <a
                    target={
                      isLinkAbsolute(
                        otherData?.field_featured_content_link?.[0]?.value
                      )
                        ? '_blank'
                        : '_self'
                    }
                  >
                    <div
                      className={`image-wrapper ${otherData?.field_featured_content_link?.[0]?.value ? 'hover-pointer' : ''} `}
                    >
                      <div
                        className="bg-image"
                        style={{
                          backgroundImage: `url('${Constants.cloudinaryImage + otherData.field_image.webimage}')`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          backgroundRepeat: 'no-repeat',
                        }}
                      />
                      <div className="overlay" />
                      <div className="logo-overlay">
                        {otherData.field_template_logo.webimage ? (
                          <Image
                            src={otherData.field_template_logo.webimage}
                            width={160}
                            height={60}
                            alt="Logo"
                          />
                        ) : null}
                      </div>
                    </div>
                  </a>
                </Link>
              </div>
            </div>
          ) : null}
          <div className={data.length ? `items items-${data.length}` : 'items'}>
            {renderRelated()}
          </div>
        </div>
      </div>
      {marketoTrigger && (
        <FacilityModal global={global} lang={lang}>
          {
            otherData?.field_cta_bar_button_selection[0]?.cta_bar_button
              ?.field_marketo_blocks[0]?.marketo_form_facility_block_type
          }
        </FacilityModal>
      )}
    </>
  );
}
